<template>
    <div>
        <b-card class="bg-default-card no-padding" v-if="milestone && trajectory && project">
            <b-tabs card v-model="milestoneShowTabState">
                <b-tab :title="uLang('app.entity_details', { entity: lang('app.milestone') })" active>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="inner">
                                <div class="mb-3">
                                    <router-link class="btn btn-brand" :to="{ name: 'admin.trajectory_projects.trajectories.milestones.edit', params: { projectId: this.projectId, trajectoryId: this.trajectoryId, id: this.id } }">{{ uLang('app.edit_type', { type: lang('app.milestone') }) }}</router-link>
                                    <a class="btn btn-brand" v-if="$can('create-milestones')" href="#" @click.prevent="duplicate">{{ uLang('app.duplicate_type', { type: lang('app.milestone') }) }}</a>
                                </div>

                                <table class="table">
                                    <tr>
                                        <td width="200">{{ uLang('app.project_name') }}:</td>
                                        <td>
                                            <router-link :to="{ name: 'admin.trajectory_projects.view', params: { id: project.id }}">
                                                {{ project.name }}
                                            </router-link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.trajectory_name') }}:</td>
                                        <td>
                                            <router-link :to="{ name: 'admin.trajectory_projects.trajectories.view', params: { projectId: project.id, id: trajectory.id }}">
                                                {{ trajectory.name }}
                                            </router-link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.name') }}:</td>
                                        <td>{{ milestone.name }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.depends_on') }}:</td>
                                        <td>{{ Number.isInteger(milestone.depends_on_milestone_id) ? milestone.depends_on_milestone.name : uLang('app.' + milestone.depends_on) }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.lead_time_in_days') }}:</td>
                                        <td>{{ milestone.lead_time_in_days }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.lead_time_of') }}:</td>
                                        <td>{{ Number.isInteger(milestone.lead_time_of_milestone_id) ? milestone.lead_time_of_milestone.name : uLang('app.' + milestone.lead_time_of) }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.maximum_hours') }}:</td>
                                        <td>{{ milestone.maximum_hours }}</td>
                                    </tr>
                                    <tr>
                                        <td width="200">{{ uLang('app.description') }}:</td>
                                        <td>{{ milestone.description }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab :title="uLang('app.actions')">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="pull-right mb-3">
                                <router-link class="btn btn-brand" :to="{ name: 'admin.trajectory_projects.trajectories.milestones.actions.create', params: { projectId: this.projectId, trajectoryId: this.trajectoryId, milestoneId: this.id } }">{{ uLang('app.add_type', { type: lang('app.action') }) }}</router-link>
                            </div>

                            <action-table :url="route('trajectory-projects.trajectories.milestones.actions.table_with_milestone_names', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.id })"
                                          :trajectory-project="project" :trajectory="trajectory" :milestone="milestone"/>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    import ActionTable from '~/components/tables/admin/projects/action/table'
    import ActionForm from '~/components/forms/admin/projects/action/form'

    export default {
        name: 'show',
        props: {
            projectId: {
                required: true,
            },
            trajectoryId: {
                required: true,
            },
            id: {
                required: true,
            },
        },

        components: {
            'action-form': ActionForm,
            'action-table': ActionTable,
        },

        data() {
            return {
                project: undefined,
                trajectory: undefined,
                milestone: undefined,
            }
        },

        created() {
            this.retrieveProject();
            this.retrieveTrajectory();
            this.retrieveMilestone();
        },

        methods: {
            createAction() {
                this.$router.push({ name: 'admin.trajectory_projects.trajectories.milestones.actions.create', params: { projectId: this.projectId, trajectoryId: this.trajectoryId, milestoneId: this.id } });
            },

            async retrieveProject() {
                const {data} = await window.axios.get(route('trajectory-projects.show', { trajectory_project: this.projectId }));
                this.project = data;
            },

            async retrieveTrajectory() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.show', { trajectory_project: this.projectId, trajectory: this.trajectoryId }));
                this.trajectory = data;
            },

            async retrieveMilestone() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.milestones.show', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.id }));
                this.milestone = data;
            },

            edit() {
                this.$router.push({ name: 'admin.trajectory_projects.trajectories.milestones.edit', params: { projectId: this.projectId, trajectory: this.trajectoryId, milestone: this.id } })
            },

            async duplicate() {
                let {data} = await window.axios.post(route('trajectory-projects.trajectories.milestones.duplicate', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.id }));

                this.$router.push({ name: 'admin.trajectory_projects.trajectories.milestones.edit', params: { trajectory_project: this.projectId, trajectory: this.trajectoryId, id: data.id }});
            },
        },

        computed: {
            overrideEndpoint() {
                return route('trajectory-projects.trajectories.milestones.actions.store', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.id })
            },
            milestoneShowTabState: {
                get () { return this.$store.getters.tabState('milestone-show') },
                set (v) { this.$store.commit('SET_TAB_STATE', { name: 'milestone-show', value: v }) }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .card-block {
        padding: 0 !important;
    }
</style>